import React from 'react';
import { Box, CircularProgress, useTheme } from '@mui/material';

const TotalOverlap = ({ totalOverlap, info }) => {
    const theme = useTheme();
    const border = theme.palette.grey[500];
    const col1 = theme.palette.primary.light;
    const col2 = theme.palette.primary.dark;
    const textPrimary = theme.palette.text.primary;
    const textSecondary = theme.palette.text.secondary;
    const radius = 15;
    const width = 100;
    var x1, x2;

    if (totalOverlap === 0) {
        x1 = 30;
        x2 = 70;
    } else {
        var mid = width / 2;
        x1 = (mid - radius) + (totalOverlap / 100) * radius;
        x2 = (mid + radius) - (totalOverlap / 100) * radius;
    }

    if (info.length === 0) {
        return (
            <CircularProgress />
        );
    } else {
        return (
            <Box maxWidth="700px">
                <svg viewBox={`0 0 ${width} 50`}
                    xmlns="http://www.w3.org/2000/svg"
                    style={{"border":`1px solid ${textSecondary}`}}>

                    <circle cx={x1} cy="25" r={radius} stroke={border}
                        fill={col1} strokeWidth="0.3" opacity="0.8" />
                    <circle cx={x2} cy="25" r={radius} stroke={border}
                        fill={col2} strokeWidth="0.3" opacity="0.8" />
                    <text
                        x="50%" y="50%"
                        textAnchor="middle"
                        fontSize={2 + totalOverlap / 20}
                        alignmentBaseline="middle" stroke="border" 
                        fill={textPrimary}>
                        {totalOverlap}%
                    </text>
                    <text x={x1} y="8" textAnchor="middle" fontSize="4" 
                        fill={textPrimary}>
                        {info[0].Ticker}
                    </text>
                    <text x={x2} y="8" textAnchor="middle" fontSize="4" 
                        fill={textPrimary}>
                        {info[1].Ticker}
                    </text>
                </svg>
            </Box>
        );
    }
}

export default TotalOverlap;